export default "__VITE_ASSET__DMf5x5gb__"